import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";
// 客户体系
export default {
    path: '/client',
    component: Layout,
    redirect: '/client/manage/index',
    alwaysShow: true,
    meta: {
        title: '客户',
        icon: 'menu_kh_off',
        modules: [21000]
    },
    children: [
        {
            path: 'manage',
            component: routerView,
            redirect: '/client/manage/index',
            meta: {
                title: '客户管理',
                icon: 'spot',
                modules: [21003]
            },
            children: [
                {
                    path: 'index',
                    name: 'EnterpriseManage',
                    component: () => import('@/views/crm/clientManage/index'),
                    meta: {
                        title: '客户管理',
                        breadcrumb: false,
                        keepAlive: true,
                        modules: [21003]
                    }
                },
                {
                    path: 'addClient',
                    name: 'AddClient',
                    component: () => import('@/views/crm/clientManage/addClient'),
                    hidden: true,
                    meta: {
                        title: '新增客户品牌',
                        activeMenu: '/client/manage/index',
                        modules: [21003]
                    }
                },
                {
                    path: 'clientDetail/:id',
                    name: 'ManageClientDetail',
                    component: () => import('@/views/crm/clientManage/clientDetail'),
                    hidden: true,
                    meta: {
                        title: '客户详情',
                        activeMenu: '/client/manage/index',
                        isDetail: true,
                        modules: [21003]
                    }
                },
                {
                    path: 'channelDetail/:id',
                    name: 'ManageChannelDetail',
                    component: () => import('@/views/crm/clientManage/channelDetail'),
                    hidden: true,
                    meta: {
                        title: '客户详情',
                        activeMenu: '/client/manage/index',
                        isDetail: true,
                        modules: [21003]
                    }
                },
                {
                    path: 'brandDetail/:id',
                    name: 'ManageBrandDetail',
                    component: () => import('@/views/crm/clientManage/brandDetail'),
                    hidden: true,
                    meta: {
                        title: '客户品牌详情',
                        activeMenu: '/client/manage/index',
                        isDetail: true,
                        modules: [21003]
                    }
                },
                {
                    path: 'channelBrandDetail/:id',
                    name: 'ManageChannelBrandDetail',
                    component: () => import('@/views/crm/clientManage/channelBrandDetail'),
                    hidden: true,
                    meta: {
                        title: '客户品牌详情',
                        activeMenu: '/client/manage/index',
                        isDetail: true,
                        modules: [21003]
                    }
                }
            ]
        },
        {
            path: 'openSea',
            redirect: '/client/openSea/index',
            component: routerView,
            meta: {
                title: '客户公海',
                icon: 'spot',
                modules: [21007]
            },
            children: [
                {
                    path: 'index',
                    component: () => import('@/views/crm/openSea/index'),
                    name: 'CrmOpenSeaIndex',
                    meta: { title: '客户公海', breadcrumb: false, modules: [21007], keepAlive: true }
                },
                {
                    path: 'detail/:id',
                    component: () => import('@/views/crm/openSea/detail'),
                    name: 'CrmOpenSeaDetail',
                    hidden: true,
                    meta: { title: '客户详情', activeMenu: '/client/openSea/index', modules: [21007] }
                },
                {
                    path: 'adminDetail/:id',
                    component: () => import('@/views/crm/openSea/detail'),
                    name: 'CrmOpenSeaDetail-Admin',
                    hidden: true,
                    meta: { title: '客户详情', activeMenu: '/client/openSea/index', modules: [21007] }
                },
                {
                    path: 'history/:id',
                    component: () => import('@/views/crm/openSea/detail'),
                    name: 'CrmOpenSeaDetail-History',
                    hidden: true,
                    meta: { title: '客户历史详情', activeMenu: '/client/openSea/index', modules: [21007] }
                }
            ]
        },
        {
            path: 'toolBox',
            component: routerView,
            redirect: '/client/toolBox/index',
            meta: {
                title: '工具',
                icon: 'spot',
                modules: [21005]
            },
            children: [
                {
                    path: 'index',
                    name: 'Tools',
                    component: () => import('@/views/crm/toolBox/index'),
                    meta: {
                        breadcrumb: false,
                        title: '工具',
                        modules: [21005]
                    }
                },
                {
                    path: 'queryRep',
                    name: 'QueryRep',
                    component: routerView,
                    redirect: '/client/toolBox/queryRep/index',
                    hidden: true,
                    meta: {
                        title: '客户查询',
                        icon: 'spot',
                        modules: [21011]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'queryRepIndex',
                            component: () => import('@/views/crm/toolBox/queryRep/index'),
                            meta: {
                                title: '客户查询',
                                activeMenu: '/client/toolBox/index',
                                breadcrumb: false,
                                keepAlive: true,
                                modules: [21011]
                            }
                        }
                    ]
                },
                {
                    path: 'waringOffCustomer',
                    name: 'WaringOffCustomer',
                    hidden: true,
                    component: () => import('@/views/crm/toolBox/waringOffCustomer'),
                    meta: {
                        title: '客户预警',
                        keepAlive: true,
                        activeMenu: '/client/toolBox/index',
                        modules: [21012]
                    }
                },
                {
                    path: 'auditClient',
                    component: routerView,
                    redirect: '/client/toolBox/auditClient/index',
                    hidden: true,
                    meta: {
                        title: '审批直客客户',
                        keepAlive: true,
                        activeMenu: '/client/toolBox/index',
                        modules: [21013]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'AuditClient',
                            component: () => import('@/views/crm/toolBox/auditClient/index'),
                            meta: {
                                title: '审批直客客户',
                                breadcrumb: false,
                                keepAlive: true,
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'auditFirm/:id',
                            name: 'AuditFirm',
                            component: () => import('@/views/crm/toolBox/auditClient/channelForm'),
                            props: {
                                isAudit: true,
                                type: 2
                            },
                            meta: {
                                title: '审批企业',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'editFirm/:id',
                            component: () => import('@/views/crm/toolBox/auditClient/channelForm'),
                            props: {
                                type: 2
                            },
                            meta: {
                                title: '编辑企业',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'auditZooid/:id',
                            component: () => import('@/views/crm/toolBox/auditClient/zooidForm'),
                            props: {
                                isAudit: true,
                                type: 2
                            },
                            meta: {
                                title: '审批个人',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'editZooid/:id',
                            component: () => import('@/views/crm/toolBox/auditClient/zooidForm'),
                            props: {
                                type: 2
                            },
                            meta: {
                                title: '编辑个人',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'auditBrand/:id',
                            component: () => import('@/views/crm/toolBox/auditClient/brandForm'),
                            props: {
                                isAudit: true
                            },
                            meta: {
                                title: '审批品牌',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'editBrand/:id',
                            component: () => import('@/views/crm/toolBox/auditClient/brandForm'),
                            meta: {
                                title: '编辑品牌',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'clientDetail/:id',
                            component: () => import('@/views/crm/clientManage/clientDetail'),
                            props: {
                                isAudit: true
                            },
                            meta: {
                                isDetail: true,
                                title: '客户详情',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        },
                        {
                            path: 'brandDetail/:id',
                            component: () => import('@/views/crm/clientManage/brandDetail'),
                            props: {
                                isAudit: true
                            },
                            meta: {
                                isDetail: true,
                                title: '客户品牌详情',
                                activeMenu: '/client/toolBox/index',
                                modules: [21013]
                            }
                        }
                    ]
                },
                {
                    path: 'channelManage',
                    component: routerView,
                    redirect: '/client/toolBox/channelManage/index',
                    hidden: true,
                    meta: {
                        title: '渠道管理',
                        modules: [21014]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'ChannelManage',
                            component: () => import('@/views/crm/toolBox/channelManage/index'),
                            meta: {
                                title: '渠道管理',
                                breadcrumb: false,
                                keepAlive: true,
                                activeMenu: '/client/toolBox/index',
                                modules: [21014]
                            }
                        },
                        {
                            path: 'addChannel',
                            name: 'AddChannel',
                            component: () => import('@/views/crm/toolBox/channelManage/channelForm'),
                            props: {
                                type: 1
                            },
                            meta: {
                                title: '新增渠道',
                                activeMenu: '/client/toolBox/index',
                                modules: [21014]
                            }
                        },
                        {
                            path: 'editChannel/:id',
                            name: 'EditChannel',
                            component: () => import('@/views/crm/toolBox/channelManage/channelForm'),
                            props: {
                                type: 1
                            },
                            meta: {
                                title: '编辑渠道',
                                activeMenu: '/client/toolBox/index',
                                modules: [21014]
                            }
                        },
                        {
                            path: 'channelDetail/:id',
                            name: 'ChannelDetail',
                            component: () => import('@/views/crm/toolBox/channelManage/channelDetail'),
                            meta: {
                                title: '渠道详情',
                                activeMenu: '/client/toolBox/index',
                                isDetail: true,
                                modules: [21014]
                            }
                        },
                        {
                            path: 'addZooid',
                            name: 'AddZooid',
                            component: () => import('@/views/crm/toolBox/channelManage/zooidForm'),
                            props: {
                                type: 1
                            },
                            meta: {
                                title: '新增个人',
                                activeMenu: '/client/toolBox/index',
                                modules: [21014]
                            }
                        },
                        {
                            path: 'editZooid/:id',
                            name: 'EditZooid',
                            component: () => import('@/views/crm/toolBox/channelManage/zooidForm'),
                            props: {
                                type: 1
                            },
                            meta: {
                                title: '编辑个人',
                                activeMenu: '/client/toolBox/index',
                                modules: [21014]
                            }
                        },
                        {
                            path: 'zooidDetail/:id',
                            name: 'ZooidDetail',
                            component: () => import('@/views/crm/toolBox/channelManage/zooidDetail'),
                            meta: {
                                title: '个人详情',
                                activeMenu: '/client/toolBox/index',
                                isDetail: true,
                                modules: [21014]
                            }
                        }
                    ]
                },
                {
                    path: 'openSeaAudit',
                    redirect: '/client/toolBox/openSeaAudit/index',
                    component: routerView,
                    hidden: true,
                    meta: {
                        title: '审批公海',
                        icon: 'spot',
                        modules: [21015]
                    },
                    children: [
                        {
                            path: 'index',
                            component: () => import('@/views/crm/toolBox/openSeaAudit/index'),
                            name: 'CrmOpenSeaAuditIndex',
                            meta: {
                                title: '审批公海',
                                activeMenu: '/client/toolBox/index',
                                breadcrumb: false,
                                modules: [21015],
                                keepAlive: true
                            }
                        },
                        {
                            path: 'detail/:id',
                            component: () => import('@/views/crm/toolBox/openSeaAudit/detail'),
                            name: 'CrmOpenSeaAuditDetail',
                            hidden: true,
                            meta: {
                                title: '客户详情',
                                activeMenu: '/client/toolBox/index',
                                modules: [21015]
                            }
                        },
                        {
                            path: 'adminDetail/:id',
                            component: () => import('@/views/crm/toolBox/openSeaAudit/detail'),
                            name: 'CrmOpenSeaAuditDetail-Admin',
                            hidden: true,
                            meta: {
                                title: '客户详情',
                                activeMenu: '/client/toolBox/index',
                                modules: [21015]
                            }
                        },
                        {
                            path: 'history/:id',
                            component: () => import('@/views/crm/toolBox/openSeaAudit/detail'),
                            name: 'CrmOpenSeaAuditDetail-History',
                            hidden: true,
                            meta: {
                                title: '客户历史详情',
                                activeMenu: '/client/toolBox/index',
                                modules: [21015]
                            }
                        }
                    ]
                },
                {
                    path: 'autoReport',
                    redirect: '/client/toolBox/autoReport/index',
                    component: routerView,
                    hidden: true,
                    meta: {
                        title: '自动报备通过',
                        icon: 'spot',
                        modules: [21016]
                    },
                    children: [
                        {
                            path: 'index',
                            component: () => import('@/views/crm/toolBox/autoReport/index'),
                            name: 'AutoReport',
                            meta: {
                                title: '自动报备通过',
                                activeMenu: '/client/toolBox/index',
                                breadcrumb: false,
                                modules: [21016],
                                keepAlive: true
                            }
                        }
                    ]
                },
                {
                    path: 'customerFollow',
                    name: 'CustomerFollow',
                    hidden: true,
                    component: () => import('@/views/crm/toolBox/customerFollow'),
                    meta: {
                        title: '客户跟进情况',
                        keepAlive: true,
                        activeMenu: '/client/toolBox/index',
                        modules: [21017]
                    }
                },
                {
                    path: 'auditChannel',
                    component: routerView,
                    redirect: '/client/toolBox/auditChannel/index',
                    hidden: true,
                    meta: {
                        title: '审批渠道客户',
                        keepAlive: true,
                        activeMenu: '/client/toolBox/index',
                        modules: [21018]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'AuditChannel',
                            component: () => import('@/views/crm/toolBox/auditChannel/index'),
                            meta: {
                                title: '审批渠道客户',
                                breadcrumb: false,
                                keepAlive: true,
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'auditFirm/:id',
                            component: () => import('@/views/crm/toolBox/channelManage/channelForm'),
                            props: {
                                isAudit: true,
                                type: 1
                            },
                            meta: {
                                title: '审批企业',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'editFirm/:id',
                            component: () => import('@/views/crm/toolBox/channelManage/channelForm'),
                            props: {
                                type: 1
                            },
                            meta: {
                                title: '编辑企业',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'auditZooid/:id',
                            component: () => import('@/views/crm/toolBox/channelManage/zooidForm'),
                            props: {
                                isAudit: true,
                                type: 1
                            },
                            meta: {
                                title: '审批个人',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'editZooid/:id',
                            component: () => import('@/views/crm/toolBox/channelManage/zooidForm'),
                            props: {
                                type: 1
                            },
                            meta: {
                                title: '编辑个人',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'auditBrand/:id',
                            component: () => import('@/views/crm/toolBox/auditClient/brandForm'),
                            props: {
                                isAudit: true
                            },
                            meta: {
                                title: '审批品牌',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'auditAgentBrand/:id',
                            component: () => import('@/views/crm/toolBox/auditChannel/agentBrandForm'),
                            props: {
                                isAudit: true
                            },
                            meta: {
                                title: '审批品牌',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'clientDetail/:id',
                            component: () => import('@/views/crm/clientManage/channelDetail'),
                            props: {
                                isAudit: true
                            },
                            meta: {
                                isDetail: true,
                                title: '客户详情',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'editBrand/:id',
                            component: () => import('@/views/crm/toolBox/auditChannel/agentBrandForm'),
                            meta: {
                                title: '编辑品牌',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'brandDetail/:id',
                            name: 'ChannelBrandDetail',
                            component: () => import('@/views/crm/clientManage/channelBrandDetail'),
                            props: {
                                isAudit: true
                            },
                            meta: {
                                isDetail: true,
                                title: '客户品牌详情',
                                activeMenu: '/client/toolBox/index',
                                modules: [21018]
                            }
                        },
                        {
                            path: 'channelBrandDetail/:id',
                            component: () => import('@/views/crm/clientManage/channelBrandDetail'),
                            hidden: true,
                            meta: {
                                title: '客户品牌详情',
                                activeMenu: '/client/toolBox/index',
                                isDetail: true,
                                modules: [21018]
                            }
                        }
                    ]
                },
                {
                    path: 'customerHandover',
                    name: 'customerHandover',
                    hidden: true,
                    component: () => import('@/views/crm/toolBox/customerHandover'),
                    meta: {
                        title: '客户交接',
                        keepAlive: true,
                        activeMenu: '/client/toolBox/index',
                        modules: [21019]
                    }
                }
            ]
        }
    ]

};
